import React, { useEffect, useRef, useState } from 'react';
import './ManageServices.scss';
import PostHeader from '../../../components/Header/PostHeader';
import downArrow from '../../../Assets/images/PostActivation/Account/DROP_ICON.svg';
import upArrow from '../../../Assets/images/PostActivation/Account/CLOSE_ICON.svg';
import _ from 'lodash';
import { useDispatch, useSelector } from 'react-redux';
import { customerGroup } from '../../../store/PostActivation/actions';
import { CircularProgress } from '@material-ui/core';
import {
    getStatusIRILDDR,
    getUsageDR,
    getUsageILD,
    getUsageIR,
    toggleIRILDDR,
} from '../../../store/Billing/actions';
import Button from '../../../components/Button/Button';
import Switch from '@material-ui/core/Switch';
import moment from 'moment';
import { toNumber } from 'lodash';
import backArrow from '../../../Assets/images/PostActivation/Account/backArrow.svg';
import SelectDropDown from '../../../components/SelectDropDown/SelectDropDown';
import leftArrow from '../../../Assets/images/PostActivation/Account/Chevron_Right.svg';
import rightArrow from '../../../Assets/images/PostActivation/Account/Chevron_Right 2.svg';
import { textTruncate } from '../../../global/commonFunctions/TextTruncate';
import GenericError from '../../../components/GenericError/GenericError';
import { getHigherNumberMBorGBFromBytes } from '../../../global/commonFunctions/ConverDataFromBytes';
import { GetCustomer } from '../../../store/Checkout/actions';
import { returnName } from '../../../global/commonFunctions/getUserName';

type initialProps = {
    history?: any;
    passedName: any;
    data: any;
    hideManageServices: any;
};

const ManageServices = (props: initialProps) => {
    const [loader, setLoader] = useState<boolean>(true);
    const [user, setUser] = useState<any>(null);
    const [groupData, setGroupData] = useState<any>(null);
    const [pauseUserData, setPauseUserData] = useState<any>('');
    const [viewUserHistory, setViewUserHistory] = useState<any>('');
    const [isViewMoreData, setIsViewMoreData] = useState<any>('');
    const [showStartDate, setShowStartDate] = useState<any>(null);
    const [showEndDate, setShowEndDate] = useState<any>(null);
    const [curService, setCurService] = useState<any>('');
    const [showRates, setShowRates] = useState<boolean>(false);
    const [selectedCountry, setSelectedCountry] = useState<any>('Select Country');
    const [countryPricing, setCountryPricing] = useState<any>('');
    const [usageData, setUsageData] = useState<any>('');
    const [stateILD, setStateILD] = useState<any>('');
    const [btnLoader, setBtnLoader] = useState<boolean>(false);
    const [isLeftArrow, setIsLeftArrow] = useState(false);
    const [isRightArrow, setIsRightArrow] = useState(false);
    const [width, setWidth] = useState<any>(window.innerWidth);
    // const [curIndex, setCurIndex] = useState<number>(0);
    // const [usageLength, setUsageLength] = useState<any>(0);
    const [currBillData, setCurrBillData] = useState<any>(null);
    const [isIR, setIsIR] = useState<boolean>(false);
    const [isILD, setIsILD] = useState<boolean>(false);
    const [isDR, setIsDR] = useState<boolean>(false);
    const [creditLimitError, setCreditLimitError] = useState(false);
    const [noPayError, setNoPayError] = useState(false);
    const [isGenericError, setIsGenericError] = useState(false);
    const [hsdError, setHsdError] = useState(false);
    const [configs, setConfigs] = useState<any>(null);
    const [intlRoamCountries, setIntlRoamCountries] = useState<any>(null);
    const [inProgressText, setInProgressText] = useState<any>('');
    const [sortedUsageEndDate, setSortedUsageEndDate] = useState<any>(null);
    const [isFraudAcc, setIsFraudAcc] = useState<boolean>(false);
    const [simSwapInProgress, setSimSwapInProgress] = useState<boolean>(false);

    const { postActivation, billing } = useSelector((state: any) => state);
    const {getCustomer} = useSelector((state: any) => state.checkout);
    const configState = useSelector((state: any) => state.billing.config);
    const dispatch = useDispatch();
    const { passedName } = props;
    const { heading, listItems, historyKey, historyVal, desc, countriesTxt } = props.data;

    useEffect(() => {
        window.addEventListener("resize", handleResize, false);
        let customerDetails: any = localStorage.getItem('customerDetail');
        customerDetails = JSON.parse(customerDetails);
        setUser(customerDetails);
        if(customerDetails?.category === 'FRAUD') {
            setIsFraudAcc(true);
        }

        const payload: any = { customerId: customerDetails && customerDetails.groupId };
        if (passedName == 'International Roaming') {
            setCurService('IR');
            setIsIR(true);
            dispatch(getUsageIR(payload));
        } else if (passedName == 'International Calling') {
            setCurService('ILD');
            setIsILD(true);
            dispatch(getUsageILD(payload));
        } else if (passedName == 'Domestic Roaming') {
            setCurService('DR');
            setIsDR(true);
            dispatch(getUsageDR(payload));
        }
        dispatch(getStatusIRILDDR({ customerId: customerDetails?.id }));
        dispatch(GetCustomer({ username: encodeURIComponent(customerDetails && customerDetails.emailId) }));
        // dispatch(config(configPayload));
        setInitialDates();
    }, []);

    const initialRender1 = useRef(true);
    useEffect(() => {
        if (initialRender1.current) {
            initialRender1.current = false;
        } else {
            if (
                postActivation &&
                postActivation.group &&
                postActivation.group.data &&
                postActivation.group.data.length > 0
            ) {
                setLoader(false);
                setGroupData(postActivation.group.data);
            }
        }
    }, [postActivation.group]);

    const initialRender2 = useRef(true);
    useEffect(() => {
        if (initialRender2.current) {
            initialRender2.current = false;
        } else {
            if (billing.toggleIRILDDR && billing.toggleIRILDDR.status === 'SUCCESS' && billing.toggleIRILDDR.data) {
                dispatch(getStatusIRILDDR({ customerId: user?.id }));
            }
            if (billing && billing.errorToggleIRILDDR && billing.errorToggleIRILDDR.status === 'FAILURE') {
                setBtnLoader(false);
                setInProgressText('');
                if (billing.errorToggleIRILDDR.resCode === 40625) {
                    setCreditLimitError(true);
                }
                if (billing.errorToggleIRILDDR.resCode === 40624) {
                    setNoPayError(true);
                    setPauseUserData('');
                }
                if (
                    billing.errorToggleIRILDDR.resCode === 40616 ||
                    billing.errorToggleIRILDDR.resCode === 40617 ||
                    billing.errorToggleIRILDDR.resCode === 40618 ||
                    billing.errorToggleIRILDDR.resCode === 40619 ||
                    billing.errorToggleIRILDDR.resCode === 40620 ||
                    billing.errorToggleIRILDDR.resCode === 40621
                ) {
                    dispatch(getStatusIRILDDR({ customerId: user?.id }));
                }

                if (billing.errorToggleIRILDDR.resCode === 40622) {
                    setIsGenericError(true);
                } else if (billing.errorToggleIRILDDR.resCode === 40623) {
                    setHsdError(true);
                } else {
                    setIsGenericError(true);
                }
            }
        }
    }, [billing.toggleIRILDDR, billing.errorToggleIRILDDR]);

    const initialRender3 = useRef(true);
    useEffect(() => {
        if (initialRender3.current) {
            initialRender3.current = false;
        } else {
            if (billing && billing.getStatusIRILDDR && billing.getStatusIRILDDR.data) {
                dispatch(customerGroup({ groupId: user && user.groupId }));
                setStateILD(billing.getStatusIRILDDR.data);
                setBtnLoader(false);
                setPauseUserData('');
                setInProgressText('');
            }
        }
    }, [billing.getStatusIRILDDR]);

    const initialRender4 = useRef(true);
    useEffect(() => {
        if (initialRender4.current) {
            initialRender4.current = false;
        } else {
            if (
                billing &&
                billing.getUsageIR &&
                billing.getUsageIR.data
                // && Object.keys(billing.getUsageIR.data).length > 0
            ) {
                let billCycle: any = localStorage.getItem('billCycle');
                billCycle = JSON.parse(billCycle);
                if (billCycle && billCycle.length > 0) {
                    setIsLeftArrow(true);
                }
                // const usageIndex = Object.keys(billing.getUsageIR.data).length - 1;
                // setUsageLength(usageIndex);
                // setCurIndex(usageIndex);

                // const sortedKeys = Object.keys(billing.getUsageIR.data).sort((a: any, b: any) => {
                //     const date1: any = new Date(a);
                //     const date2: any = new Date(b);
                //     return date1 - date2;
                // });
                setUsageData(billing.getUsageIR.data);
                setSortedUsageEndDate(billCycle);

                let customerDetails: any = localStorage.getItem('customerDetail');
                customerDetails = JSON.parse(customerDetails);
                const endDate = moment
                    .utc(customerDetails?.nextBillingDate)
                    .subtract(1, 'days')
                    .format('YYYY-MM-DD');
                const data = billing.getUsageIR.data[endDate];
                setShowStartDate(
                    data && data[Object.keys(data)[0]][0]?.billStartDate
                        ? data[Object.keys(data)[0]][0].billStartDate
                        : showStartDate,
                );
                setShowEndDate(
                    data && data[Object.keys(data)[0]][0]?.billEndDate
                        ? data[Object.keys(data)[0]][0].billEndDate
                        : showEndDate,
                );
                Object.keys(billing.getUsageIR.data)?.map((el: any) => {
                    if (el === endDate) {
                        setCurrBillData(billing.getUsageIR.data[el]);
                    }
                });
            }
        }
    }, [billing.getUsageIR]);

    const initialRender5 = useRef(true);
    useEffect(() => {
        if (initialRender5.current) {
            initialRender5.current = false;
        } else {
            if (
                billing &&
                billing.getUsageDR &&
                billing.getUsageDR.data
                // && Object.keys(billing.getUsageDR.data).length > 0
            ) {
                let billCycle: any = localStorage.getItem('billCycle');
                billCycle = JSON.parse(billCycle);
                if (billCycle && billCycle.length > 0) {
                    setIsLeftArrow(true);
                }
                // const usageIndex = Object.keys(billing.getUsageDR.data).length - 1;
                // setUsageLength(usageIndex);
                // setCurIndex(usageIndex);
                // const sortedKeys = Object.keys(billing.getUsageDR.data).sort((a: any, b: any) => {
                //     const date1: any = new Date(a);
                //     const date2: any = new Date(b);
                //     return date1 - date2;
                // });
                setUsageData(billing.getUsageDR.data);
                setSortedUsageEndDate(billCycle);

                let customerDetails: any = localStorage.getItem('customerDetail');
                customerDetails = JSON.parse(customerDetails);
                const endDate = moment
                    .utc(customerDetails?.nextBillingDate)
                    .subtract(1, 'days')
                    .format('YYYY-MM-DD');
                const data = billing.getUsageDR.data[endDate];
                setShowStartDate(
                    data && data[Object.keys(data)[0]][0]?.billStartDate
                        ? data[Object.keys(data)[0]][0].billStartDate
                        : showStartDate,
                );
                setShowEndDate(
                    data && data[Object.keys(data)[0]][0]?.billEndDate
                        ? data[Object.keys(data)[0]][0].billEndDate
                        : showEndDate,
                );
                Object.keys(billing.getUsageDR.data)?.map((el: any) => {
                    if (el === endDate) {
                        setCurrBillData(billing.getUsageDR.data[el]);
                    }
                });
            }
        }
    }, [billing.getUsageDR]);

    const initialRender6 = useRef(true);
    useEffect(() => {
        if (initialRender6.current) {
            initialRender6.current = false;
        } else {
            if (
                billing &&
                billing.getUsageILD &&
                billing.getUsageILD.data
                // && Object.keys(billing.getUsageILD.data).length > 0
            ) {
                let billCycle: any = localStorage.getItem('billCycle');
                billCycle = JSON.parse(billCycle);
                if (billCycle && billCycle.length > 0) {
                    setIsLeftArrow(true);
                }
                // const usageIndex = Object.keys(billing.getUsageILD.data).length - 1;
                // setUsageLength(usageIndex);
                // setCurIndex(usageIndex);
                // const sortedKeys = Object.keys(billing.getUsageILD.data).sort((a: any, b: any) => {
                //     const date1: any = new Date(a);
                //     const date2: any = new Date(b);
                //     return date1 - date2;
                // });
                setUsageData(billing.getUsageILD.data);
                setSortedUsageEndDate(billCycle);

                let customerDetails: any = localStorage.getItem('customerDetail');
                customerDetails = JSON.parse(customerDetails);
                const endDate = moment
                    .utc(customerDetails?.nextBillingDate)
                    .subtract(1, 'days')
                    .format('YYYY-MM-DD');
                const data = billing.getUsageILD.data[endDate];
                setShowStartDate(data?.billStartDate ? data.billStartDate : showStartDate);
                setShowEndDate(data?.billEndDate ? data.billEndDate : showEndDate);
                Object.keys(billing.getUsageILD.data)?.map((el: any) => {
                    if (el === endDate) {
                        setCurrBillData(billing.getUsageILD.data[el].usageDetail);
                    }
                });
            }
        }
    }, [billing.getUsageILD]);

    useEffect(() => {
        if (configState && configState.status === 'SUCCESS' && configState.data) {
            setConfigs(configState.data.configs);
            if (isILD) {
                const filteredCountries: any = configState.data.intlRoamingCountries.countriesList.filter(
                    (el: any) => el.ildStatus === 1,
                );
                setIntlRoamCountries(filteredCountries);
            } else {
                const filteredCountries: any = configState.data.intlRoamingCountries.countriesList.filter(
                    (el: any) => el.status === 1,
                );
                setIntlRoamCountries(filteredCountries);
            }
        }
    }, [configState]);

    const initialRender7 = useRef(true)
    useEffect(()=> {
        if (initialRender7.current) {
            initialRender7.current = false;
        } else {
            if (
                getCustomer &&
                getCustomer.status === 'SUCCESS' &&
                getCustomer.data &&
                getCustomer.data.operationsInProcess
            ) {
                if (getCustomer.data.operationsInProcess.includes('SIM_SWAP_IN_PROGRESS')) {
                    setSimSwapInProgress(true);
                    let customerDetails: any = localStorage.getItem('customerDetail');
                    customerDetails = JSON.parse(customerDetails);
                    let timer: any = 60000;
                    setTimeout(() => {
                        dispatch(
                            GetCustomer({ username: encodeURIComponent(customerDetails && customerDetails.emailId) }),
                        );
                    }, timer);
                } else {
                    setSimSwapInProgress(false);
                }
            }
        }
    },[getCustomer])

    const handleResize = () => {
        setWidth(window.innerWidth);
    }


    const setInitialDates = () => {
        let customerDetails: any = localStorage.getItem('customerDetail');
        customerDetails = JSON.parse(customerDetails);
        const nextBillingDate = new Date(
            moment
                .utc(customerDetails.nextBillingDate)
                .subtract(1, 'months')
                .format('YYYY-MM-DD'),
        );
        const activationDate = new Date(moment.utc(customerDetails.activationDate).format('YYYY-MM-DD'));
        const showEndDate = new Date(
            moment
                .utc(customerDetails.nextBillingDate)
                .subtract(1, 'days')
                .format('YYYY-MM-DD'),
        );
        const activationDate_yr = activationDate.getFullYear();
        const nextBillingDate_yr = nextBillingDate.getFullYear();
        const activationDate_mth = activationDate.getMonth();
        const nextBillingDate_mth = nextBillingDate.getMonth();
        const activationDate_dt = activationDate.getDate();
        const nextBillingDate_dt = nextBillingDate.getDate();
        if (
            nextBillingDate_yr > activationDate_yr ||
            nextBillingDate_mth > activationDate_mth ||
            (nextBillingDate_mth === activationDate_mth && nextBillingDate_dt > activationDate_dt)
        ) {
            setShowStartDate(nextBillingDate);
            setShowEndDate(showEndDate);
        } else {
            setShowStartDate(activationDate);
            setShowEndDate(showEndDate);
        }
    };

    const handleEnableService = (id: any, action: boolean) => {
        setBtnLoader(true);
        const payload: any = {
            customerId: id,
            serviceType: curService,
            action: !action ? 'ENABLE' : 'DISABLE',
        };
        if (!action) {
            Object.assign(payload, { reason: 'Voluntary' });
        }
        dispatch(toggleIRILDDR(payload));
    };

    const onChangeHandler = async (e: any) => {
        setSelectedCountry(e.target.value);
        const result = intlRoamCountries.find((el: any) => el.countryName === e.target.value);
        setCountryPricing(result);
    };

    const backHandler = () => {
        if (showRates) {
            setShowRates(false);
        } else {
            props.hideManageServices();
        }
    };

    const onLeftClickHandler = () => {
        // setCurIndex(prevState => prevState - 1);
        // if (curIndex - 1 <= 0) {
        //     setIsLeftArrow(false);
        //     setIsRightArrow(true);
        // }

        const currentDateIndex = sortedUsageEndDate.indexOf(moment.utc(showEndDate).format('YYYY-MM-DD'));
        const endDate: any = moment.utc(sortedUsageEndDate[currentDateIndex - 1]).format('YYYY-MM-DD');
        const startDateData: any = new Date(
            moment
                .utc(endDate)
                .add(1, 'days')
                .subtract(1, 'months')
                .format('YYYY-MM-DD'),
        );
        const endDateData: any = new Date(moment.utc(endDate).format('YYYY-MM-DD'));
        if (sortedUsageEndDate[0] === endDate) {
            setIsLeftArrow(false);
        }
        setIsRightArrow(true);
        let userBillStartDate = null;
        let userBillEndDate = null;
        if (isILD) {
            userBillStartDate = usageData[endDate]?.billStartDate ? usageData[endDate]?.billStartDate : null;
        } else {
            const key = Object.keys(usageData).includes(endDate) && Object.keys(usageData[endDate])[0];
            userBillStartDate =
                key && usageData[endDate][key][0]?.billStartDate ? usageData[endDate][key][0]?.billStartDate : null;
        }
        setShowStartDate(userBillStartDate ? userBillStartDate : startDateData);
        setShowEndDate(userBillEndDate ? userBillEndDate : endDateData);
        Object.keys(usageData)?.map((el: any) => {
            if (Object.keys(usageData).includes(endDate)) {
                if (el === endDate) {
                    if (isILD) {
                        setCurrBillData(usageData[el].usageDetail);
                    } else {
                        setCurrBillData(usageData[el]);
                    }
                }
            } else {
                setCurrBillData(null);
            }
        });
    };

    const onRightClickHandler = () => {
        // setCurIndex(prevState => prevState + 1);
        // if (curIndex + 1 == usageLength) {
        //     setIsLeftArrow(true);
        //     setIsRightArrow(false);
        // }

        const currentDateIndex = sortedUsageEndDate.indexOf(moment.utc(showEndDate).format('YYYY-MM-DD'));
        const endDate: any = moment.utc(sortedUsageEndDate[currentDateIndex + 1]).format('YYYY-MM-DD');
        const startDateData: any = new Date(
            moment
                .utc(endDate)
                .add(1, 'days')
                .subtract(1, 'months')
                .format('YYYY-MM-DD'),
        );
        const endDateData: any = new Date(moment.utc(endDate).format('YYYY-MM-DD'));
        if (moment.utc(endDate).format('YYYY-MM-DD') === moment.utc(user.billEndDate).format('YYYY-MM-DD')) {
            setIsRightArrow(false);
        }
        setIsLeftArrow(true);
        let userBillStartDate = null;
        let userBillEndDate = null;
        if (isILD) {
            userBillStartDate = usageData[endDate]?.billStartDate ? usageData[endDate]?.billStartDate : null;
        } else {
            const key = Object.keys(usageData).includes(endDate) && Object.keys(usageData[endDate])[0];
            userBillStartDate =
                key && usageData[endDate][key][0]?.billStartDate ? usageData[endDate][key][0]?.billStartDate : null;
        }
        setShowStartDate(userBillStartDate ? userBillStartDate : startDateData);
        setShowEndDate(userBillEndDate ? userBillEndDate : endDateData);
        Object.keys(usageData)?.map((el: any) => {
            if (Object.keys(usageData).includes(endDate)) {
                if (el === endDate) {
                    if (isILD) {
                        setCurrBillData(usageData[el].usageDetail);
                    } else {
                        setCurrBillData(usageData[el]);
                    }
                }
            } else {
                setCurrBillData(null);
            }
        });
    };

    const viewHistoryHandler = (el: any) => {
        setPauseUserData('');
        if (viewUserHistory === el.id) {
            setViewUserHistory('');
            setIsViewMoreData('');
        } else {
            setViewUserHistory(el.id);
        }
        // setInitialDates();
    };

    const handleGenericErrorCTA = () => {
        setIsGenericError(false);
    };
    function convertToOrdinal(number: any) {
        const ordinalWords = ['First', 'Second', 'Third', 'Fourth', 'Fifth', 'Sixth'];
        const value = parseInt(number);
        return ordinalWords[value];
    }

    return (
        <div className="ServicesMain">
            <PostHeader 
                history={props.history} 
                showServiceTab={billing?.config?.data?.configs?.SERVICE_TAB === 'ENABLE' ? true : false}
                // enableServiceInPrimarySus={billing?.config?.data?.configs?.ENABLE_LINE_SERVICES_WHEN_PRIMARY_SUSPENEDED} 
            />
            {isGenericError ? (
                <GenericError handleGenericErrorCTA={handleGenericErrorCTA} />
            ) : (
                <div className="planDetails">
                    <img src={backArrow} alt="backArrow" className="backArrow" onClick={backHandler} />
                    <div className="planTitle">
                        <div className="planName">{props.passedName}</div>
                    </div>
                    {((user && user.status === 3 && user.isPrimary) || noPayError || isFraudAcc) && (
                        <div className="suspendedDiv">
                            <div className="suspendedTitle">Let’s Talk</div>
                            <div className="suspendedMsg">
                                We’re sorry. The service you’re attempting to access or update is temporarily
                                unavailable.
                            </div>
                            <div className="suspendedContact">
                                Please contact us at <span>1.800.427.8686</span>
                            </div>
                        </div>
                    )}

                    {loader ? (
                        <div className="loaderCheck">
                            <CircularProgress />
                        </div>
                    ) : !showRates ? (
                        <div className="ServiceLineCardContainer">
                            <div className="headerLine">
                                <div>Line</div>
                                <div>Service status</div>
                            </div>
                            {groupData &&
                                billing.getUsageIR &&
                                groupData
                                    .filter(
                                        (el: any) => el?.status === 2 ||
                                        el?.status == 3
                                        // el?.status == 4 ||
                                        // el?.status == 5 ||
                                        // el?.status == 6,
                                    )
                                    .sort(
                                        (x: any, y: any) =>
                                            y.isPrimary - x.isPrimary ||
                                            toNumber(x.peerAccountRef?.split('|')[2]) -
                                                toNumber(y.peerAccountRef?.split('|')[2]),
                                    )
                                    .map((el: any, _idx: any) => {
                                        let arr: any = [];
                                        stateILD?.map((e: any, _idx: number) => {
                                            if (el.id == Object.keys(e)) {
                                                arr.push(e);
                                            }
                                        });
                                        let status: any = null;
                                        let desiredValue: boolean = false;
                                        if (arr?.length > 0) {
                                            if (el.id == Object.keys(arr[0])) {
                                                status = Object.values(arr[0]);
                                            }
                                        }
                                        if (isIR && status) {
                                            desiredValue = status[0]?.irEnabled;
                                        } else if (isILD && status) {
                                            desiredValue = status[0]?.ildEnabled;
                                        } else if (isDR && status) {
                                            desiredValue = status[0]?.drEnabled;
                                        }
                                        const findUserHistory =
                                            usageData &&
                                            usageData.length > 0 &&
                                            usageData?.find((data: any) => data.customerId === viewUserHistory);

                                        let usageHisData: any = null;
                                        let totalDataUsage: any;
                                        let datausage: any;
                                        let smsUsage: any;
                                        let voiceUsage: any;
                                        let countriesVisited: any;
                                        let countriesUsage: any = [];
                                        let IRVisitedCountries: any = [];
                                        if (isIR) {
                                            if (currBillData) {
                                                Object.keys(currBillData)?.map((elem: any) => {
                                                    if (elem === el.id) {
                                                        usageHisData = Object.values(currBillData[elem]);
                                                    }
                                                });
                                            }
                                            if (usageHisData) {
                                                totalDataUsage = usageHisData[0]?.dataUsage?.totalUsage;
                                                if (totalDataUsage) {
                                                    datausage = getHigherNumberMBorGBFromBytes(totalDataUsage);
                                                }
                                                smsUsage = usageHisData[0]?.smsUsage?.totalUsage;
                                                voiceUsage = usageHisData[0]?.voiceUsage?.totalUsage;
                                                countriesVisited = usageHisData[0]?.visitedZoneCountries;
                                                intlRoamCountries && countriesVisited &&
                                                    intlRoamCountries.find((el: any) => {
                                                        countriesVisited.map((code: any) => {
                                                            if (el.countryCode == code) {
                                                                IRVisitedCountries.push(el.countryName);
                                                            }
                                                        });
                                                    });
                                            }
                                        } else if (isILD) {
                                            if (currBillData) {
                                                Object.keys(currBillData)?.map((elem: any) => {
                                                    if (elem === el.id) {
                                                        usageHisData = currBillData[elem];
                                                        if(usageHisData && usageHisData.countryUsageMap) {
                                                            countriesVisited = usageHisData.countryUsageMap;
                                                            Object.values(countriesVisited)?.map((el: any) => {
                                                                countriesUsage.push(el.voiceUsage);
                                                            });
                                                        }
                                                    }
                                                });
                                            }
                                        } else {
                                            if (currBillData) {
                                                Object.keys(currBillData)?.map((elem: any) => {
                                                    if (elem === el.id) {
                                                        usageHisData = Object.values(currBillData[elem]);
                                                    }
                                                });
                                            }
                                            if (usageHisData) {
                                                totalDataUsage = usageHisData[0]?.dataUsage?.totalUsage
                                                    ? usageHisData[0]?.dataUsage?.totalUsage
                                                    : usageHisData[0]?.dataUsageOverall;
                                                if (totalDataUsage) {
                                                    datausage = getHigherNumberMBorGBFromBytes(totalDataUsage);
                                                }
                                                smsUsage = usageHisData[0]?.smsUsage?.totalUsage
                                                    ? usageHisData[0]?.smsUsage?.totalUsage
                                                    : usageHisData[0]?.smsUsageOverall;
                                                voiceUsage = usageHisData[0]?.voiceUsage?.totalUsage
                                                    ? usageHisData[0]?.voiceUsage?.totalUsage
                                                    : usageHisData[0]?.voiceUsageOverall;
                                            }
                                        }

                                        return (
                                            <div
                                                className={
                                                    pauseUserData === el.id && !desiredValue
                                                        ? 'AccountLineCardHeight AccountLineCard'
                                                        : // : el.status === 2
                                                        //     ? 'AccountLineHeight'
                                                        viewUserHistory === el.id
                                                        ? 'AccountLineCardHistoryHeight AccountLineCard'
                                                        : 'AccountLineCard'
                                                }
                                                key={el.id}
                                            >
                                                <>
                                                    <div className="AccountTopDiv">
                                                        <div className="AccountCusDetails">
                                                        <span
                                                                className={
                                                                    el.status === 4 ? 'cusDetailsLite username' : 'username'
                                                                }
                                                            >
                                                                 {el?.firstName || el?.lastName
                                                                    ? width <= 768 ? textTruncate(returnName(el, "firstName")) + ' ' + textTruncate(returnName(el, "lastName"))?.toUpperCase() : returnName(el, "firstName") + ' ' + returnName(el, "lastName")
                                                                    : convertToOrdinal(
                                                                          el.peerAccountRef?.split('|')[2] - 1,
                                                                      ).toUpperCase() + "'s" + ' LINE'}{' '}
                                                            </span>
                                                            <br />
                                                            {el.status === 4 ? (
                                                                <span className="cusStatus">Disconnected</span>
                                                            ) : (
                                                                <span className="AccountCusSimPref">
                                                                    <span className="AccountCusPrimary">
                                                                        {el &&
                                                                            el.reachNumber &&
                                                                            `(${el.reachNumber.slice(
                                                                                0,
                                                                                3,
                                                                            )}) ${el.reachNumber.slice(
                                                                                3,
                                                                                6,
                                                                            )}-${el.reachNumber.slice(6)} `}
                                                                    </span>
                                                                </span>
                                                            )}
                                                            {el.isPrimary && (
                                                                <span className="AccountCusPrimary">(Primary)</span>
                                                            )}{' '}
                                                        </div>
                                                        <div className="AccountHLine"></div>
                                                        {el.status === 4 ? (
                                                            <>
                                                                <div className="AccountVLine"></div>
                                                                <div className="activationFailed">
                                                                    <div
                                                                        className="showMore"
                                                                        onClick={() => {
                                                                            setPauseUserData('');
                                                                            if (viewUserHistory === el.id) {
                                                                                setViewUserHistory('');
                                                                            } else {
                                                                                setViewUserHistory(el.id);
                                                                            }
                                                                        }}
                                                                    >
                                                                        {viewUserHistory === el.id
                                                                            ? 'Show Less Info'
                                                                            : 'Show More Info'}
                                                                        <img
                                                                            src={
                                                                                viewUserHistory === el.id
                                                                                    ? upArrow
                                                                                    : downArrow
                                                                            }
                                                                            alt="historyIcon"
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </>
                                                        ) : (
                                                            <div className="AccountCusRightDiv">
                                                                <div
                                                                    className="AccountDataHistory"
                                                                    onClick={() => viewHistoryHandler(el)}
                                                                >
                                                                    {viewUserHistory === el.id
                                                                        ? 'Hide Usage History'
                                                                        : 'View Usage History'}
                                                                    <span className="historyIcon">
                                                                        <img
                                                                            src={
                                                                                viewUserHistory === el.id
                                                                                    ? upArrow
                                                                                    : downArrow
                                                                            }
                                                                            alt="historyIcon"
                                                                        />
                                                                    </span>
                                                                </div>
                                                                <div className="AccountVLine"></div>
                                                                <div
                                                                    className={
                                                                        // (user.status === 3 && user.isPrimary) ||
                                                                        // el.status === 3 ||
                                                                        (el.status === 3 && 
                                                                            !billing?.config?.data?.configs?.       ENABLE_LINE_SERVICES_WHEN_PRIMARY_SUSPENEDED ||
                                                                            user?.meta?.suspended_reason === "NonPay Suspension" || isFraudAcc
                                                                        ) ||
                                                                            noPayError
                                                                            ? 'AccountDataSwitchDisabled AccountDataSwitch'
                                                                            : 'AccountDataSwitch'
                                                                    }
                                                                >
                                                                    {el.id !== inProgressText ? (
                                                                        <Switch
                                                                            checked={desiredValue}
                                                                            onChange={() => {
                                                                                if (desiredValue) {
                                                                                    setInProgressText(el.id);
                                                                                    handleEnableService(
                                                                                        el.id,
                                                                                        desiredValue,
                                                                                    );
                                                                                    desiredValue = !desiredValue;
                                                                                } else {
                                                                                    setInProgressText('');
                                                                                }
                                                                                setHsdError(false)
                                                                                setViewUserHistory('');
                                                                                setCreditLimitError(false);
                                                                                if (pauseUserData === el.id) {
                                                                                    setPauseUserData('');
                                                                                } else {
                                                                                    setPauseUserData(el.id);
                                                                                }
                                                                            }}
                                                                            disabled={
                                                                                (el.status === 3 && 
                                                                                    !billing?.config?.data?.configs?.ENABLE_LINE_SERVICES_WHEN_PRIMARY_SUSPENEDED ||
                                                                                    user?.meta?.suspended_reason === "NonPay Suspension") ||
                                                                                    isFraudAcc ||
                                                                                simSwapInProgress ||
                                                                                noPayError ||
                                                                                el.id === inProgressText ||
                                                                                btnLoader
                                                                            }
                                                                            name="pausedata"
                                                                            inputProps={{
                                                                                'aria-label': 'primary checkbox',
                                                                            }}
                                                                        />
                                                                    ) : (
                                                                        <div className="loaderCheck requestInProgress">
                                                                            <CircularProgress />
                                                                        </div>
                                                                    )}
                                                                    <div className="AccountDataText">
                                                                        {el.id === inProgressText
                                                                            ? 'Request in Progress'
                                                                            : desiredValue
                                                                            ? 'Enabled'
                                                                            : 'Disabled'}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        )}
                                                    </div>
                                                </>
                                                {el.id === pauseUserData && creditLimitError && (
                                                    <div className="AccountBottomDiv">
                                                        <div className="AccountHLine"></div>
                                                        <div className="AccountDataDiv">
                                                            <div>
                                                                <div className="AccountDataTitle">Let's Talk</div>
                                                                <div className="AccountDataNote">
                                                                    We’re sorry. The service you’re attempting to access
                                                                    or update is temporarily unavailable. <br />
                                                                    Please contact us at <span>1.800.427.8686</span>
                                                                </div>
                                                            </div>
                                                            <div className="AccountChangePlanButton">
                                                                <Button
                                                                    onClick={() => {
                                                                        handleEnableService(el.id, desiredValue);
                                                                    }}
                                                                    primary={true}
                                                                    disabled={true}
                                                                >
                                                                    Enable Service
                                                                </Button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                )}
                                                {el.id === pauseUserData && !creditLimitError && (
                                                    <div className="AccountBottomDiv">
                                                        <div className="AccountHLine"></div>
                                                        <div className="AccountDataDiv">
                                                            {!desiredValue && !hsdError && (
                                                                <>
                                                                    <div className="AccountDataNote">
                                                                        {isIR
                                                                            ? 'Voice, SMS & Data usage will be charged on a pay-as-you-go basis in your upcoming invoice.'
                                                                            : isILD
                                                                            ? 'Voice & SMS usage will be charged on a pay-as-you-go basis in your upcoming invoice.'
                                                                            : 'SMS & Data will be charged on a pay-as-you-go basis in your upcoming invoice. Voice is provided at no additional cost.'}
                                                                        <div
                                                                            className="terms"
                                                                            onClick={() => {
                                                                                window.open(
                                                                                    process.env
                                                                                    .REACT_APP_ASTOUND_TERMS_AND_CONDITIONS_URL,
                                                                                    );
                                                                                }}
                                                                                >
                                                                            TERMS & CONDITIONS
                                                                        </div>
                                                                    </div>
                                                                    <div className="AccountChangePlanButton">
                                                                        <Button
                                                                            onClick={() => {
                                                                                !btnLoader && handleEnableService(el.id, desiredValue);
                                                                            }}
                                                                            primary={true}
                                                                        >
                                                                            {btnLoader ? (
                                                                                <div className="loaderCheck">
                                                                                    <CircularProgress />
                                                                                </div>
                                                                            ) : (
                                                                                'Enable Service'
                                                                            )}
                                                                        </Button>
                                                                    </div>
                                                                </>
                                                            )}
                                                            {hsdError && (
                                                                <div className='infoMsg'>Your Astound Mobile service activation request for {curService === 'ILD' ? 'International Calling' : curService === 'IR' ? 'International Roaming' : 'Domestic Roaming'} could not be completed at this time. Please reach out to our Astound Care Team at <span>1.800.427.8686</span> for assistance.</div>
                                                            )}
                                                        </div>
                                                    </div>
                                                )}
                                                {el.id === viewUserHistory && el.status === 4 && (
                                                    <>
                                                        <div className="HomeBottomLine"></div>
                                                        <div className="BottomDivContent">
                                                            <div className="BottomDivTitle">Line Disconnected</div>
                                                            <div className="BottomDivMsg">
                                                                {el.lastDisconnectedReason === 0
                                                                    ? 'As requested, your '
                                                                    : 'Your '}
                                                                line has been disconnected. For any queries or questions
                                                                please get in touch with our Care Team at{' '}
                                                                <span>1.800.427.8686</span>
                                                            </div>
                                                        </div>
                                                    </>
                                                )}
                                                {el.id === viewUserHistory && el.status !== 4 && (
                                                    <div className="AccountBottomHistory">
                                                        <div className="AccountHLine"></div>
                                                        <div
                                                            className="AccountUsageText"
                                                            style={{ textAlign: 'center' }}
                                                        >
                                                            Usage History
                                                        </div>
                                                        <div className="AccountHistoryDateDiv">
                                                            <span
                                                                className={!isLeftArrow ? 'arrowDisabled' : ''}
                                                                onClick={onLeftClickHandler}
                                                            >
                                                                <img src={leftArrow} alt="leftArrow" />
                                                            </span>
                                                            <div className="AccountHistoryDate">
                                                                {showStartDate &&
                                                                    moment
                                                                        .utc(showStartDate)
                                                                        .format('MMM DD, YYYY')}{' '}
                                                                -{' '}
                                                                {showEndDate &&
                                                                    moment.utc(showEndDate).format('MMM DD, YYYY')}
                                                            </div>
                                                            <span
                                                                className={!isRightArrow ? 'arrowDisabled' : ''}
                                                                onClick={onRightClickHandler}
                                                            >
                                                                <img src={rightArrow} alt="rightArrow" />
                                                            </span>
                                                        </div>
                                                        <div className="AccountHistoryDetails">
                                                            <div className="AccountHistoryTopupDetails">
                                                                <div className="AccountHistoryDetailsTitle">
                                                                    <div
                                                                        className={
                                                                            // !topupHistory ||
                                                                            !findUserHistory
                                                                                ? 'AccountTopupHistoryUnavailable AccountTopupHistory'
                                                                                : isViewMoreData === el.id
                                                                                ? 'AccountTopupHistoryScroll AccountTopupHistory'
                                                                                : 'AccountTopupHistory'
                                                                        }
                                                                    >
                                                                        {usageHisData ? (
                                                                            <>
                                                                                {countriesTxt && (
                                                                                    <div className="countriesTxt">
                                                                                        {countriesTxt}
                                                                                        {IRVisitedCountries?.join(',')}
                                                                                    </div>
                                                                                )}
                                                                                <div className="ServiceHistoryTitle">
                                                                                    <div>{historyKey}</div>
                                                                                    <div>{historyVal}</div>
                                                                                </div>
                                                                                <div className="AccountHLine"></div>
                                                                                <div className="ServiceUsageCont">
                                                                                    {isIR ? (
                                                                                        <>
                                                                                            <div>
                                                                                                <div className="key">
                                                                                                    Data
                                                                                                </div>
                                                                                                <div className="key">
                                                                                                    Voice
                                                                                                </div>
                                                                                                <div className="key">
                                                                                                    SMS
                                                                                                </div>
                                                                                            </div>
                                                                                            <div>
                                                                                                <div className="value">
                                                                                                    {datausage &&
                                                                                                        datausage}{' '}
                                                                                                </div>
                                                                                                <div className="value">
                                                                                                    {`${voiceUsage} mins`}{' '}
                                                                                                </div>
                                                                                                <div className="value">
                                                                                                    {smsUsage &&
                                                                                                        smsUsage}
                                                                                                </div>
                                                                                            </div>
                                                                                        </>
                                                                                    ) : isILD && countriesVisited ? (
                                                                                        <>
                                                                                            <div>
                                                                                                {Object.keys(
                                                                                                    countriesVisited,
                                                                                                ).map(
                                                                                                    (
                                                                                                        el: any,
                                                                                                        id: number,
                                                                                                    ) => (
                                                                                                        <div
                                                                                                            className="key"
                                                                                                            key={id}
                                                                                                        >
                                                                                                            {el}
                                                                                                        </div>
                                                                                                    ),
                                                                                                )}
                                                                                            </div>
                                                                                            <div
                                                                                            // style={{
                                                                                            //     marginRight: '50px',
                                                                                            // }}
                                                                                            >
                                                                                                {countriesUsage && 
                                                                                                Object.values(
                                                                                                    countriesUsage,
                                                                                                ).map(
                                                                                                    (
                                                                                                        el: any,
                                                                                                        id: number,
                                                                                                    ) => (
                                                                                                        <div
                                                                                                            key={id}
                                                                                                            className="value"
                                                                                                        >
                                                                                                            {el}
                                                                                                        </div>
                                                                                                    ),
                                                                                                )}
                                                                                            </div>
                                                                                        </>
                                                                                    ) : (
                                                                                        <>
                                                                                            <div>
                                                                                                <div className="key">
                                                                                                    Data
                                                                                                </div>
                                                                                                <div className="key">
                                                                                                    Voice
                                                                                                </div>
                                                                                                <div className="key">
                                                                                                    SMS
                                                                                                </div>
                                                                                            </div>
                                                                                            <div>
                                                                                                <div className="value">
                                                                                                    {datausage
                                                                                                        ? datausage
                                                                                                        : '0'}{' '}
                                                                                                </div>
                                                                                                <div className="value">
                                                                                                    {voiceUsage
                                                                                                        ? `${voiceUsage} mins`
                                                                                                        : '0 mins'}{' '}
                                                                                                </div>
                                                                                                <div className="value">
                                                                                                    {smsUsage
                                                                                                        ? smsUsage
                                                                                                        : '0'}{' '}
                                                                                                    {/* {smsUsage ?
                                                                                                    `${smsUsage} mins` : 0}{' '} */}
                                                                                                </div>
                                                                                            </div>
                                                                                        </>
                                                                                    )}
                                                                                </div>
                                                                            </>
                                                                        ) : (
                                                                            <div className="errorTopupHistory">
                                                                                You don’t have any usage in the selected
                                                                                bill cycle.
                                                                            </div>
                                                                        )}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        {usageHisData && (
                                                            <div className="noteBelowUsage">
                                                                <strong>Note: </strong> Your usage is charged on a
                                                                pay-as-you-go basis. The details of the charges are in
                                                                your invoice.
                                                            </div>
                                                        )}
                                                    </div>
                                                )}
                                            </div>
                                        );
                                    })}
                            <div className="hline"></div>
                            {props.data && (
                                <>
                                    <div className="bottomContainer">
                                        <div className="bottomInfo">
                                            <div className={`heading ${isDR && 'text-center'}`}>{heading}</div>
                                            {listItems &&
                                                listItems.map((el: any, _idx: number) => (
                                                    <div className="listItems" key={_idx}>
                                                        <li>{el}</li>
                                                    </div>
                                                ))}
                                            {desc && (
                                                <>
                                                    <div className="desc">{desc}</div>
                                                    <div className="table">
                                                        <div className="details">
                                                            <div>Data</div>
                                                            <div className="rates">
                                                                ${configs?.DR_DATA_COST}/{configs?.DR_DATA_PULSE_UNIT}
                                                            </div>
                                                        </div>
                                                        <div className="vLine"></div>
                                                        <div className="details">
                                                            <div>Voice</div>
                                                            <div className="rates">
                                                                ${configs?.DR_VOICE_COST}/min<sup>*</sup>
                                                            </div>
                                                        </div>
                                                        <div className="vLine"></div>
                                                        <div className="details">
                                                            <div>SMS</div>
                                                            <div className="rates">${configs?.DR_SMS_COST}/SMS</div>
                                                        </div>
                                                    </div>
                                                    <div className="voiceNote">
                                                        *Voice is provided at no additional cost
                                                    </div>
                                                </>
                                            )}
                                            {!desc && (
                                                <div
                                                    className="ratesBtn"
                                                    onClick={() => {
                                                        window.scroll(0, 0);
                                                        setShowRates(true);
                                                    }}
                                                >
                                                    View Rates
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </>
                            )}
                        </div>
                    ) : (
                        <div className="viewRatesContainer">
                            <div className="viewRatesHead">View Rates</div>
                            <div className="viewRatesDesc">
                                The pay-as-you-go service charges you for only your usage at the end of your billing
                                cycle.
                            </div>
                            <div className="dropDownContainer">
                                <div className="countryTitle">COUNTRY</div>
                                <SelectDropDown
                                    key={intlRoamCountries}
                                    value={selectedCountry}
                                    options={intlRoamCountries}
                                    onChange={(e: any) => {
                                        onChangeHandler(e);
                                    }}
                                    showDropDownIcon={true}
                                />
                            </div>
                            {curService == 'IR' ? (
                                <div className="table">
                                    <div className="details">
                                        <div>Data</div>
                                        <div className="rates">
                                            {countryPricing?.pricePerPulse
                                                ? `$${countryPricing?.pricePerPulse?.toFixed(2)}/${
                                                      configs?.IR_DATA_PULSE_UNIT
                                                  }`
                                                : '--'}
                                        </div>
                                    </div>
                                    <div className="vLine"></div>
                                    <div className="details">
                                        <div>Voice</div>
                                        <div className="rates">
                                            {countryPricing?.voiceOut
                                                ? `$${countryPricing?.voiceOut?.toFixed(2)}/min`
                                                : '--'}
                                        </div>
                                    </div>
                                    <div className="vLine"></div>
                                    <div className="details">
                                        <div>SMS</div>
                                        <div className="rates">
                                            {countryPricing?.smsOut
                                                ? `$${countryPricing?.smsOut?.toFixed(2)}/SMS`
                                                : '--'}
                                        </div>
                                    </div>
                                </div>
                            ) : (
                                <div className="table" style={{ width: '200px' }}>
                                    <div className="details">
                                        <div>Voice</div>
                                        <div className="rates">
                                            {countryPricing?.ildVoiceOut
                                                ? `$${countryPricing?.ildVoiceOut?.toFixed(2)}/min`
                                                : '--'}
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    )}
                </div>
            )}
        </div>
    );
};

export default ManageServices;
